/*====================================================
	APP: Tipo
====================================================*/

// Remove copyright from all steps
const checkRdvCopyrightStept1Interval = setInterval(() => {
	const rdvCopyrightStep1 = document.querySelector('.tpb-booking-form .step1 .copyright');
	if (rdvCopyrightStep1) {
		rdvCopyrightStep1.remove();
		clearInterval(checkRdvCopyrightStept1Interval);
	}
}, 200);
const checkRdvCopyrightStept2Interval = setInterval(() => {
	const rdvCopyrightStep2 = document.querySelector('.tpb-booking-form .step2 .copyright');
	if (rdvCopyrightStep2) {
		rdvCopyrightStep2.remove();
		clearInterval(checkRdvCopyrightStept2Interval);
	}
}, 200);
const checkRdvCopyrightStept3Interval = setInterval(() => {
	const rdvCopyrightStep3 = document.querySelector('.tpb-booking-form .step3 .copyright');
	if (rdvCopyrightStep3) {
		rdvCopyrightStep3.remove();
		clearInterval(checkRdvCopyrightStept3Interval);
	}
}, 200);